module.exports = __webpack_public_path__ + "static/media/Lato-Black.d2d9ddbd.eot";